import React from "react";
import { makeStyles, Typography, Grid } from "@material-ui/core";

import SelectBox from "../../../../../components/SelectBox";

export const useStyles = makeStyles((theme) => ({
  selectContainer: {
    display: "flex",
    alignItems: "center"
  },
  selectRoot: {
    color: theme.palette.grey["900"]
  },
  head: {
    fontWeight: 700,
    letterSpacing: 0.2
  }
}));

const AlertBoxHeader = ({
  options1,
  options2,
  title,
  label1,
  label2,
  send,
  to,
  changeInsights,
  type
}) => {
  const classes = useStyles();

  const getSelectedValue = (types, selectedValue) => {
    if (
      ["weekly", "daily", "yearly", "hourly"].includes(
        selectedValue?.toLowerCase()
      )
    ) {
      changeInsights({ [`${types}_interval`]: selectedValue?.toUpperCase() });
    } else if (
      ["executive", "operator", "basic", "admin"].includes(
        selectedValue?.toLowerCase()
      )
    ) {
      changeInsights({ [`${types}_role`]: selectedValue?.toUpperCase() });
    }
  };

  const handleChangeUserRole = (val) => {
    getSelectedValue(type === "insight" ? "insight" : "portfolio", val);
  };

  return (
    <>
      <Grid container justifyContent="space-between" alignItems="center">
        <div>
          {title && <Typography className={classes.head}>{title}</Typography>}
        </div>
        <div className={classes.selectContainer}>
          {options1.length && (
            <SelectBox
              label={label1 ? label1 : null}
              options={options1}
              defaultValue={type === "insight" ? send : to}
              setValue={handleChangeUserRole}
              selectRoots={classes.selectRoot}
            />
          )}
          {options2.length && (
            <SelectBox
              label={label2 ? label2 : null}
              options={options2}
              setValue={handleChangeUserRole}
              defaultValue={type === "portfolio" ? send : to}
              containerStyle={{ marginLeft: 5 }}
              selectRoots={classes.selectRoot}
            />
          )}
        </div>
      </Grid>
    </>
  );
};

export default AlertBoxHeader;
